<template>
  <div>
    <!-- yy496 新增，引流弹窗 -->
    <LeadGiftDialog ref="leadDialog" :pageType="2" />
    <div
      class="sign-act"
      v-if="actInfo"
      :style="{ backgroundColor: backgroundColor, backgroundImage: `url('${actInfo.image}')` }"
    >
      <!-- 活动规则 -->
      <div class="ruleBtn" @click="showRule">活动规则</div>
      <!-- 领取记录 -->
      <div class="recordBtn" @click="showRecord">领取记录</div>

      <main>
        <!-- 账号绑定 -->
        <div class="account">
          <template v-if="userInfo.game_account || globalUserInfo.game_account">
            已绑定账号：{{ userInfo.game_account || globalUserInfo.game_account }}
            <span class="ml_8 color_link" @click="onLogswitch">切换账号</span>
          </template>
        </div>

        <!-- 签到板块 -->
        <div :class="['sign', signCheckShow ? 'signShow' : 'signHidden']">
          <header>
            <div class="sign-info">
              <div class="day">
                本周已签到<span> {{ userInfo.total_sign_in_week || 0 }} </span>天
              </div>
              <div class="sign-check" @click="checkSign">
                <span>查看签到日历</span>
                <img
                  :class="['sign-icon', signCheckShow ? 'sign-icon-trans' : '']"
                  src="https://assets.hzwxbz2.cn/sy/hm/img/arrow.png"
                />
              </div>
            </div>
            <div class="sign-btn">
              <button v-if="userInfo.sign_in_today == 1" class="signin">已签到</button>
              <button v-else @click="signin">签到</button>
            </div>
          </header>
          <ul>
            <li
              v-for="i in 7"
              :key="i"
              :class="[
                userInfo.sign_in_week && userInfo.sign_in_week[i - 1] == 1 ? 'gift-get' : '',
              ]"
            >
              <p>{{ dtd[i - 1] }}</p>
              <img
                class="gift"
                :src="
                  userInfo.sign_in_week && userInfo.sign_in_week[i - 1] == 1
                    ? signIconLight
                    : signIconDark
                "
              />
            </li>
          </ul>
        </div>

        <!-- 游戏 + 礼包 -->
        <div class="game-list">
          <!-- 游戏 -->
          <div class="icon-list">
            <div
              :style="{ backgroundImage: `url('${item.images}')` }"
              v-for="(item, index) in firstPageInfo"
              :key="index"
              :class="[actGame.id === item.id ? 'active' : '', 'gi']"
              @click="selectGame(item)"
            >
              <img :src="`${CDN_URL}/signAct/9.png?v=1`" alt="" v-if="actGame.id === item.id" />
            </div>
            <div class="more" @click="moreGameVisible = true">
              <img :src="`${CDN_URL}/signAct/9.png?v=1`" alt="" v-if="isMoreGame" class="active" />
              <img :src="`${CDN_URL}/signAct/1.png?v=1`" alt="" />
              <p>更多游戏</p>
            </div>
          </div>

          <!-- 游戏对应礼包 -->
          <div class="welfare">
            <div class="welfare-title">{{ actGame.name }}</div>
            <ul>
              <li v-for="(item, index) in welList" :key="index">
                <img :src="item.icon" alt="" />
                <div>
                  <p>{{ item.welfare_name }}</p>
                  <p>{{ item.description }}</p>
                </div>
                <button v-if="!item.gift_code" @click="receiveGift(item)">领取</button>
                <button v-else class="hasGet" @click="receiveGift(item, 1)">已领取</button>
              </li>
            </ul>
          </div>
        </div>

        <!-- 本周必看 -->
        <div class="week" id="week">
          <img class="week-icon" src="https://assets.hzwxbz2.cn/sy/hm/img/title_week.png" />
          <!-- 宣传位 -->
          <div class="week-content">
            <swiper class="week-swiper" :options="swiperOptionsHor" v-if="weekRecommendList.length">
              <swiper-slide
                v-for="(item, index) in weekRecommendList"
                :key="`${index}-${item.icon}`"
                class="week-swiper-item"
              >
                <img :src="item.icon" class="week-swiper-image" :swiper-index="index" />
                <div class="week-swiper-intro">{{ item.intro }}</div>
              </swiper-slide>
            </swiper>
          </div>
        </div>

        <!-- 热游排行榜 -->
        <div :class="$style.rank">
          <!-- 标题行 -->
          <div :class="$style.rankTitle">
            <img
              :class="$style.rankIcon"
              src="https://assets.hzwxbz2.cn/sy/hm/img/title_rank.png"
            />
            <div :class="$style.rankMore" @click="handleLinkTo('gameCenter.home')">
              查看更多榜单
            </div>
          </div>
          <!-- 热游列表 -->
          <div :class="$style.rankList">
            <div v-for="(r, ri) in rankList" :key="ri" :class="$style.ri">
              <div
                :class="$style.rankIcon"
                v-if="ri === 0"
                :style="{ backgroundImage: `url(${rankIcon_1})` }"
              ></div>
              <div
                :class="$style.rankIcon"
                v-else-if="ri === 1"
                :style="{ backgroundImage: `url(${rankIcon_2})` }"
              ></div>
              <div
                :class="$style.rankIcon"
                v-else-if="ri === 2"
                :style="{ backgroundImage: `url(${rankIcon_3})` }"
              ></div>
              <div :class="$style.rankIcon" v-else></div>
              <div :class="$style.gameItem">
                <img :src="r.images" alt="" />
                <div :class="$style.content">
                  <p :class="[$style.name, 'van-ellipsis']">{{ r.name }}</p>
                  <p :class="[$style.desc, 'van-ellipsis']">{{ r.description }}</p>
                  <p :class="$style.tags" v-if="r.label">
                    <span
                      v-for="(tag, tgi) in r.label"
                      :class="[tag.value ? $style.tag : '']"
                      :key="tgi"
                      >{{ tag.value }}</span
                    >
                  </p>
                </div>
              </div>
              <div :class="$style.download" @click="download(r, 3)">下载</div>
            </div>
          </div>
        </div>
      </main>

      <!-- 弹框 -->
      <DialogWrapper
        @closeDialog="dialogShow = false"
        v-show="dialogShow"
        class="customDialogWrapper"
      >
        <template #title>
          <template v-if="dialogType === 2"> 领取成功 </template>
          <template v-if="dialogType === 3"> 活动规则 </template>
        </template>
        <template #main-content>
          <template v-if="dialogType === 1">
            <p class="fs_18">领取礼包需激活对应游戏，</p>
            <p class="fs_18">您尚未激活该游戏。</p>
            <p class="fs_18">下载并进入游戏即可激活</p>
          </template>
          <template v-if="dialogType === 2">
            <div class="dialog-copy flex_center">
              礼包码：
              <input id="giftCode1" :value="giftCode" readonly="readonly" />
            </div>
            <p class="fs_12 mt_8" style="color: #fe4f4a">礼包有时间限制，请及时前往游戏中兑换</p>
          </template>
          <template v-if="dialogType === 3">
            <p class="ruleContent" v-html="actInfo.rules_info.replaceAll('\n', '<br>')"></p>
          </template>
          <template v-if="dialogType === 4">
            <p>本周累计签到天数未达到</p>
          </template>
          <template v-if="dialogType === 5">
            <p class="fs_18">您已领取过该礼包，</p>
            <p class="fs_18">请前往我的礼包查看哦</p>
          </template>
        </template>
        <div slot="footer" class="dialog-button">
          <button
            class="dialog-white-button"
            type="info"
            @click="onClickEntry(dialogType, 1)"
            v-if="![1, 3].includes(dialogType)"
          >
            {{ entryInfo.button_name }}
          </button>
          <button
            class="dialog-blue-button"
            type="info"
            @click="downloadGame"
            v-if="dialogType == 1"
          >
            下载游戏
          </button>
          <button
            :data-clipboard-text="giftCode"
            class="dialog-blue-button btn-submit"
            type="info"
            v-if="dialogType == 2"
            @click="onClickCopy"
          >
            复制礼包码
          </button>
          <button v-if="dialogType === 4" class="dialog-blue-button" @click="onContinueSign">
            继续签到
          </button>
          <button v-if="dialogType === 5" class="dialog-blue-button" @click="onGoMyGift">
            我的礼包
          </button>
        </div>
      </DialogWrapper>
      <!-- 选择更多游戏 -->
      <div class="more-game" v-if="moreGameVisible">
        <div class="content">
          <header>
            <span>请选择</span>
            <img :src="`${CDN_URL}/tgStore/close.png`" alt="" @click="moreGameVisible = false" />
          </header>
          <main>
            <p v-if="moreGame.online && moreGame.online.length">在玩游戏</p>
            <div
              v-if="moreGame.online"
              v-for="(item, index) in moreGame.online"
              :key="index"
              class="games"
              @click="selectGame(item)"
            >
              <img :src="item.images" alt="" />
              <p>{{ item.name }}</p>
            </div>
            <p v-if="moreGame.games && moreGame.games.length">推荐游戏</p>
            <div
              v-if="moreGame.games"
              v-for="(item, index) in moreGame.games"
              :key="index"
              class="games"
              @click="selectGame(item)"
            >
              <img :src="item.images" alt="" />
              <p>{{ item.name }}</p>
            </div>
          </main>
        </div>
      </div>
      <!-- 礼包领取记录 -->
      <div class="record" v-if="recordVisible">
        <header>
          <img :src="`${CDN_URL}/back.png`" alt="" @click="recordVisible = false" />
          <span>礼包领取记录</span>
        </header>
        <div class="icon-list">
          <div
            :style="{ backgroundImage: `url('${item.images}')` }"
            v-for="(item, index) in firstPageInfo"
            :key="index"
            :class="[actGame.id === item.id ? 'active' : '', 'gi']"
            @click="selectGame(item)"
          >
            <img :src="`${CDN_URL}/signAct/9.png?v=1`" alt="" v-if="actGame.id === item.id" />
          </div>
          <div class="more" @click="moreGameVisible = true">
            <img :src="`${CDN_URL}/signAct/9.png?v=1`" alt="" v-if="isMoreGame" class="active" />
            <img :src="`${CDN_URL}/signAct/1.png?v=1`" alt="" />
            <p>更多游戏</p>
          </div>
        </div>
        <main>
          <ul>
            <li v-for="(item, index) in recordList" :key="index">
              <div>
                <img :src="item.icon" alt="" />
                <div>
                  <p>{{ item.welfare_name }}</p>
                  <p>{{ item.description }}</p>
                </div>
                <button :data-clipboard-text="item.code" class="gift-copy">复制</button>
              </div>
              <p>领取时间：{{ item.get_time }}</p>
            </li>
          </ul>
          <Pagination
            v-if="recordTotal"
            v-model="recordPage"
            :total-items="recordTotal"
            :items-per-page="10"
            @change="pageChange"
          ></Pagination>
          <div v-else class="nodata">暂无数据</div>
        </main>
      </div>
    </div>
  </div>
</template>
<script>
import { CDN_URL } from '@/config/index.js';
import {
  actInfoApi,
  userInfoApi,
  signApi,
  firstPageApi,
  moreGameApi,
  welfareApi,
  getWelfareApi,
  receiveApi,
  disperseApi,
  rankGameListApi,
} from '@/api/signAct';
import { reportData } from '@/api/report';
import { mapState, mapMutations } from 'vuex';
import DialogWrapper from '@/views/giftCenter/components/DialogWrapper';
import Clipboard from 'clipboard';
import { Pagination } from 'vant';
import bindAccountMixin from '@/mixins/bindAccountMixin.js';
import { initEntryInfo } from '@/mixins/giftFeedbackEntryInfo';
import { getImageBottomColor } from '@/utils/getImageBottomColor';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import LeadGiftDialog from '_c/LeadGiftDialog';

import 'swiper/css/swiper.css';

export default {
  mixins: [bindAccountMixin, initEntryInfo(2, 1)],
  data() {
    return {
      CDN_URL,
      dtd: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      actId: '',
      actInfo: null,
      userInfo: {},
      firstPageInfo: [],
      moreGame: {},
      welId: '',
      welList: [],
      actGame: {},
      dialogShow: false,
      dialogType: 1, // 1.不符合条件 2.领取成功 3.活动规则
      giftCode: '',
      download_url: '',
      firstPageIds: [],
      isMoreGame: false,
      moreGameVisible: false,
      recordVisible: false,
      recordList: [],
      giftCopy: null,
      recordTotal: 0,
      recordPage: 1,
      backgroundColor: '#fff', // 背景色 - 取自背景图的底部部分
      signCheckShow: false, // 签到模块是否打开
      signIconLight: 'https://assets.hzwxbz2.cn/sy/hm/img/gift_light.png', // 签到已领取 icon
      signIconDark: 'https://assets.hzwxbz2.cn/sy/hm/img/gift_dark.png', // 签到未领取 icon
      weekRecommendList: [], // 本周必看宣传位列表
      rankList: [], // 热游排行榜
      rankIcon_1: 'https://assets.hzwxbz2.cn/sy/hm/img/top_1.png',
      rankIcon_2: 'https://assets.hzwxbz2.cn/sy/hm/img/top_2.png',
      rankIcon_3: 'https://assets.hzwxbz2.cn/sy/hm/img/top_3.png',
      originId: '',
    };
  },
  mounted() {
    this.getBaseInfo();
    this.copyInit();
    this.$nextTick(() => {
      this.listenWeekItemClick();
      this.$refs.leadDialog.initData();
    });
  },
  destroyed() {
    this.removeWeekItemClick();
  },
  computed: {
    ...mapState('account', {
      globalUserInfo: (state) => state.userInfo,
    }),
    // 推荐游戏banner
    swiperOptionsHor() {
      return {
        autoplay: {
          delay: 5000, // 每隔 5s 切换
          disableOnInteraction: false, // 用户操作后仍然自动播放
        },
        loop: true,
        slidesPerView: (200 + 138 - 3.5) / 200,
        spaceBetween: 18,
        preventClicks: false,
      };
    },
  },
  watch: {
    globalUserInfo: {
      handler(val, oldVal) {
        if (!val || !val.game_account) return;
        this.$refs.leadDialog.initData();
      },
      deep: true,
    },
  },
  methods: {
    // 跳转到游戏中心
    handleLinkTo(pathName, query) {
      reportData({
        type: 18,
        data_type: 10,
        overall_id: this.originId,
      });
      setTimeout(() => {
        this.$router.push({ name: pathName, query: query });
      }, 300);
    },
    // 获取热游推荐榜数据
    async getRankGameList() {
      try {
        const r = await rankGameListApi({});

        if (r.code !== 1) return;

        this.rankList = r.data || [];
      } catch (error) {}
    },
    // 热游下载
    download(item, download_url_type) {
      reportData({
        type: 18,
        data_type: 11,
        overall_id: this.originId,
        extend: `${item.id}-${item.name}`,
      });
      setTimeout(() => {
        window.location.href = item.download_url;
      }, 500);
    },
    // 本周必看轮播图点击
    handleWeekItemClick(e) {
      if (
        e.target &&
        e.target.attributes &&
        e.target.attributes['swiper-index'] &&
        e.target.attributes['swiper-index'].value
      ) {
        const currentIndex = e.target.attributes['swiper-index'].value;
        const currentItem = this.weekRecommendList[currentIndex];
        reportData({
          type: 18,
          data_type: 9,
          overall_id: this.originId,
          extend: currentItem.intro,
        });
        setTimeout(() => {
          // 跳转链接
          window.open(currentItem.url, '_self');
        }, 300);
      }
    },
    // 监听本周必看轮播图点击
    listenWeekItemClick() {
      document.addEventListener('click', this.handleWeekItemClick, false);
    },
    // 卸载本周必看轮播图点击
    removeWeekItemClick() {
      document.removeEventListener('click', this.handleWeekItemClick, false);
    },
    // 获取本周必看数据
    async getDisperseData() {
      const r = await disperseApi(this.actId, {});

      if (r.code !== 1) return;

      this.weekRecommendList = r.data || [];
    },
    // 点击查看签到日历
    checkSign() {
      this.signCheckShow = !this.signCheckShow;
    },
    async receiveGift(item, type) {
      this.welId = item.id;
      this.hasReceive = type;
      if (type) {
        this.giftCode = item.gift_code;
        this.handleTrack(5);
        this.triggerDialog(true, 5);
        return;
      }
      try {
        const r = await getWelfareApi(this.actId, {
          game_id: this.actGame.game_id,
          welfare_id: item.id,
        });
        if (r.data.code) {
          this.giftCode = r.data.code;
          this.triggerDialog(true, 2);
          this.getWelfare(this.actGame);
        }
      } catch (error) {
        const { code, data } = error;
        const { status, download_url } = data || {};
        if (code && code == 7) {
          if (status == 1) {
            this.download_url = download_url;
            this.triggerDialog(true, 1);
          }
          if (status == 2) {
            this.triggerDialog(true, 4);
          }
        } else {
          this.$toast(error.message);
        }
      }
    },
    showRule() {
      this.triggerDialog(true, 3);
    },
    triggerDialog(v, type) {
      if (type !== undefined) {
        this.dialogType = type;
      }
      this.dialogShow = v;
    },
    handleTrack(type, subtype) {
      const extra = {};
      if (type === 5 && !subtype) {
        extra.data_type = 5;
        extra.extend = 4;
      }
      // 1 领取成功 2 未满足领取条件 3 未激活该游戏 4 已领取
      // 1 其他惊喜福利 2 复制礼包码 3 继续签到 4 下载游戏 5 我的礼包
      if ([1, 2, 4, 5].includes(type) && subtype) {
        extra.data_type = 8;
        const typeMap = {
          1: 3,
          2: 1,
          4: 2,
          5: 4,
        };
        extra.extend = `${typeMap[type]}-${subtype}`;
      }
      reportData({
        type: 18,
        overall_id: this.originId,
        sign_in_game_id: this.actGame.game_id,
        welfare_id: this.welId,
        ...extra,
      });
    },
    beforeEntry(...args) {
      this.handleTrack(...args);
    },
    afterClickEntry() {
      this.triggerDialog(false);
    },
    copyInit() {
      // 领取游戏礼包弹窗中的点击复制
      this.copy = new Clipboard('.btn-submit');
      this.copy.on('success', (e) => {
        this.$toast.success('复制成功');
        if (!this.hasReceive) {
          // this.handleTrack(2, 2)
        }
      });
    },
    onClickCopy() {
      this.handleTrack(2, 2);
    },
    downloadGame() {
      this.handleTrack(1, 4);
      setTimeout(() => {
        window.open(this.download_url);
      }, 200);
    },
    // 去到我的礼包
    onGoMyGift() {
      this.handleTrack(5, 5);
      this.triggerDialog(false);
      setTimeout(() => {
        this.showRecord();
      }, 100);
    },
    onContinueSign() {
      this.handleTrack(4, 3);
      this.triggerDialog(false);
    },
    selectGame(item) {
      this.actGame = item;
      this.moreGameVisible = false;
      this.isMoreGame = !this.firstPageIds.includes(item.id);
      this.getWelfare(item);
      this.recordPage = 1;
      this.getRecord(item.game_id);
      reportData({
        type: 18,
        data_type: 3,
        overall_id: this.originId,
        sign_in_game_id: item.game_id,
      });
    },
    async getBaseInfo() {
      this.actId = this.$route.query.id;
      this.originId = this.$route.query.origin_id;
      reportData({
        type: 18,
        data_type: 1,
        overall_id: this.originId,
      });
      try {
        const r = await actInfoApi(this.actId);
        this.actInfo = r.data;

        if (r.data && r.data.id) {
          document.title = r.data.title;
          getImageBottomColor(r.data.image).then((color) => {
            if (color) {
              this.backgroundColor = color;
            }
          });
        }
      } catch (error) {}
      this.getUserInfo();
      this.getDisperseData();
      this.getRankGameList();
      try {
        const r = await firstPageApi(this.actId);
        this.firstPageInfo = r.data;
        if (this.firstPageInfo.length) {
          this.firstPageIds = this.firstPageInfo.map((item) => item.id);
          this.actGame = this.firstPageInfo[0];
          this.getWelfare(this.firstPageInfo[0]);
          reportData({
            type: 18,
            data_type: 3,
            overall_id: this.originId,
            sign_in_game_id: this.actGame.game_id,
          });
        }
      } catch (error) {}
      try {
        const r = await moreGameApi(this.actId);
        this.moreGame = r.data;
      } catch (error) {}
    },
    async getUserInfo() {
      try {
        const r = await userInfoApi(this.actId);
        this.userInfo = r.data;
      } catch (error) {}
    },
    async getWelfare(game) {
      const r = await welfareApi(this.actId, { game_id: game.game_id });
      this.welList = r.data;
    },
    showRecord() {
      this.recordPage = 1;
      this.getRecord(this.actGame.game_id);
      this.recordVisible = true;
    },
    pageChange() {
      this.getRecord(this.actGame.game_id);
    },
    async getRecord(game_id) {
      const r = await receiveApi(this.actId, {
        game_id: game_id,
        page: this.recordPage,
      });
      if (!r.data.data) {
        this.recordList = [];
        this.recordTotal = 0;
        return;
      }
      this.recordList = r.data.data;
      this.recordTotal = r.data.total;
      setTimeout(() => {
        if (this.giftCopy) this.giftCopy.destroy();
        this.giftCopy = new Clipboard('.gift-copy');
        this.giftCopy.on('success', (e) => {
          this.$toast.success('复制成功');
        });
      }, 500);
    },
    async signin() {
      if (!this.userInfo.game_account && !this.globalUserInfo.game_account) {
        this.CHANGE_BIND_ACCOUNT_DIALOG(true);
        return;
      }
      if (!this.userInfo.game_account && this.globalUserInfo.game_account) {
        await this.getUserInfo();
      }
      await signApi(this.actId);
      this.$toast('签到成功');
      this.getUserInfo();
    },
    onChangeAccount() {
      this.getBaseInfo();
    },
  },
  components: {
    DialogWrapper,
    Pagination,
    Swiper,
    SwiperSlide,
    LeadGiftDialog,
  },
};
</script>
<style scoped lang="scss">
@import '~@/styles/_variable.scss';
.sign-act {
  position: relative;
  width: 375px;
  min-height: 100vh;
  height: auto;
  background-repeat: no-repeat;
  background-size: contain;
  padding: 6px 5px 57px 5px;

  .ruleBtn,
  .recordBtn {
    position: absolute;
    right: 0;
    width: 50px;
    height: 18px;
    background: #484793;
    line-height: 18px;
    font-size: 10px;
    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
    font-weight: 400;
    color: #ffffff;
    border-bottom-left-radius: 9px;
    border-top-left-radius: 9px;
    padding-left: 6px;
  }

  .ruleBtn {
    top: 5px;
  }

  .recordBtn {
    top: 30px;
  }

  > main {
    width: 100%;

    .account {
      color: #ffffff;
      font-size: 12px;
      margin-bottom: 107px;
      padding-left: 15px;
    }

    .signShow {
      height: 175px;
    }
    .signHidden {
      height: 78px;
    }

    .sign {
      width: 365px;
      border-radius: 12px;
      background-color: #ffffff;
      margin: 0 auto 9px auto;
      overflow: hidden;

      transition: height 150ms linear;

      > header {
        width: 365px;
        height: 78px;
        display: flex;
        justify-content: space-between;
        padding: 17px 26px 17px 17px;
        background: #fffbf1;
        border-radius: 12px;

        > .sign-info {
          > .day {
            font-size: 18px;
            font-family: Source Han Sans CN, Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: center;
            color: #113555;
            line-height: 18px;
            margin-bottom: 10px;

            > span {
              color: #ff5043;
            }
          }

          > .sign-check {
            display: flex;
            flex-direction: row;
            align-items: center;

            > span {
              font-size: 12px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              color: #186aff;
              line-height: 18px;
              margin-right: 4px;
            }

            > .sign-icon {
              width: 10px;

              transition: transform 150ms linear;
            }

            > .sign-icon-trans {
              transform: rotateZ(180deg);
            }
          }
        }

        .sign-btn {
          width: 93px;
          height: 36px;

          > button {
            width: 93px;
            height: 36px;
            border-radius: 18px;
            display: block;
            background: #ff5043;
            border-radius: 18px;
            border: none;
            outline: none;
            font-size: 15px;
            font-family: Source Han Sans CN, Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: center;
            color: #ffffff;
            line-height: 36px;

            &.signin {
              background: #9f9f9f;
            }
          }
        }
      }

      > ul {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 15px;

        > li {
          width: 43px;
          height: 65px;
          background: #f5f5f5;
          border-radius: 8px;
          margin: 0 3.5px;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 10px 0 12px 0;

          > .gift {
            width: 21.5px;
          }

          > p {
            font-size: 10px;
            font-family: Source Han Sans CN, Source Han Sans CN-Regular;
            font-weight: 400;
            text-align: center;
            color: #c7c7c7;
            line-height: 18px;
            margin-bottom: 4px;
          }
        }

        > .gift-get {
          background: #fefaf5;

          > p {
            color: #f55956;
          }
        }
      }
    }

    .game-list {
      width: 365px;
      height: 345px;
      background: #f3f2f7;
      border-radius: 12px;
      overflow-x: hidden;
      overflow-y: auto;
      padding: 10px 8px 0 8px;
      margin-bottom: 10px;

      .icon-list {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 15px;
        background-color: #ffffff;
        border-radius: 10px;
        margin-bottom: 11px;

        > .gi {
          width: 54px;
          height: 54px;
          border-radius: 12px;
          margin-right: 14px;
          background-size: 100% 100%;
          &.active {
            width: 68px;
            height: 68px;
            position: relative;
            border-radius: 16px;
          }
          > img {
            width: 100%;
            height: 100%;
          }
        }
        > .more {
          position: relative;
          margin-left: 5px;
          > img {
            display: block;
            width: 37px;
            height: 37px;
            margin-bottom: 5px;
            &.active {
              position: absolute;
              top: -9px;
              left: -13px;
              width: 65px;
              height: 65px;
            }
          }
          > p {
            font-size: 9px;
            text-align: center;
            color: #fc5f5e;
          }
        }
      }

      .welfare {
        .welfare-title {
          font-size: 18px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 500;
          text-align: left;
          color: #000000;
          line-height: 18px;
          margin-bottom: 9px;
          padding-left: 13px;
        }

        > ul {
          > li {
            width: 348px;
            background: #ffffff;
            border-radius: 7px;
            padding: 8px 12px;
            display: flex;
            align-items: center;
            margin: auto;
            margin-bottom: 6px;
            > img {
              width: 60px;
              height: 60px;
              border-radius: 12px;
              margin-right: 14px;
            }
            > div {
              > p:nth-child(1) {
                color: #333333;
                font-size: 13px;
                font-weight: 700;
                margin-bottom: 7px;
              }
              > p:nth-child(2) {
                color: #9f7155;
                font-size: 10px;
                line-height: 13px;
                width: 180px;
              }
            }
            > button {
              width: 81px;
              height: 30px;
              background: #ff5043;
              border-radius: 15px;
              outline: none;
              border: none;
              color: #ffffff;
              font-size: 13px;
              &.hasGet {
                background: #919191;
              }
            }
          }
        }
      }
    }

    .week {
      width: 365px;
      height: 193px;
      background: #ffffff;
      border-radius: 12px;
      margin-bottom: 10px;
      padding: 9px 9px 0 9px;

      .week-icon {
        width: 71px;
        margin: 0 0 8px 0;
      }

      .week-content {
        width: 100%;
        height: calc(100% - 24px);
        overflow: hidden;

        .week-swiper {
          width: 100%;
          height: 100%;

          .week-swiper-item {
            width: 100%;
            height: 100%;

            .week-swiper-image {
              width: 100%;
              height: 129px;
              background: #cc1515;
              border-radius: 8px;
              margin-bottom: 4.5px;
            }

            .week-swiper-intro {
              width: 100%;
              font-size: 12px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: left;
              color: #313131;
              line-height: 18px;

              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              /* autoprefixer: ignore next */
              -webkit-box-orient: vertical;
            }
          }
        }
      }
    }
  }
}

.ruleContent {
  max-height: 254px;
  overflow-x: hidden;
  overflow-y: scroll;
}

.dialog-copy {
  margin-top: 23px;
  width: 305.6px;
  height: 38.8px;
  input {
    outline: none;
    border: none;
    width: 210px;
    background: #ebebeb;
    padding: 8px 12px;
    border-radius: 5px;
    font-size: 15px;
  }
}

.customDialogWrapper {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  .title {
    color: #333333;
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
  }
  .h-content {
    text-align: center;
    margin-top: 10px;
    font-size: 12px;
    color: #ff5043;
  }
  .btn-cancel {
    width: 101px;
    height: 30px;
    background: #ff5043;
    border-radius: 15px;
    outline: none;
    border: none;
    color: #ffffff;
    font-size: 14px;
    margin: 0 10px;
  }
  .btn-cancel {
    background-color: #919191;
  }
}

.more-game {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 100;
  .content {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 305px;
    height: 376px;
    background: #ffffff;
    border-radius: 8px;
    margin: auto;
    > header {
      width: 305px;
      height: 36px;
      background: #ff7f27;
      border-radius: 8px 8px 0px 0px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      > img {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 12px;
        height: 12px;
      }
    }
    > main {
      height: calc(100% - 36px);
      overflow-y: auto;
      > p {
        font-size: 19px;
        color: #ff5216;
        padding: 18px 20px;
      }
      .games {
        display: inline-block;
        width: 100px;
        height: 100px;
        text-align: center;
        > img {
          display: inline-block;
          width: 60px;
          height: 60px;
          border-radius: 6px;
          margin-bottom: 4px;
        }
        > p {
          color: #333333;
          font-size: 12px;
        }
      }
    }
  }
}

.icon-list {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 15px;
  background-color: #ffffff;
  > .gi {
    width: 54px;
    height: 54px;
    border-radius: 12px;
    margin-right: 14px;
    background-size: 100% 100%;
    &.active {
      width: 68px;
      height: 68px;
      position: relative;
      border-radius: 16px;
    }
    > img {
      width: 100%;
      height: 100%;
    }
  }
  > .more {
    position: relative;
    margin-left: 5px;
    > img {
      display: block;
      width: 37px;
      height: 37px;
      margin-bottom: 5px;
      &.active {
        position: absolute;
        top: -9px;
        left: -13px;
        width: 65px;
        height: 65px;
      }
    }
    > p {
      font-size: 9px;
      text-align: center;
      color: #fc5f5e;
    }
  }
}

.record {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f8f8f8;
  z-index: 99;
  > header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    font-size: 18px;
    font-weight: 700;
    background-color: #ffffff;
    position: relative;
    margin-bottom: 8px;
    > img {
      position: absolute;
      left: 10px;
      width: 15px;
    }
  }
  > main {
    height: calc(100% - 145px);
    overflow: auto;
    padding: 0 11px;
    > ul {
      margin-top: 10px;
      > li {
        width: 353px;
        background: #ffffff;
        border-radius: 7px;
        padding: 8px 12px;
        margin: auto;
        margin-bottom: 6px;
        > div {
          display: flex;
          align-items: center;
          margin-bottom: 11px;
          > img {
            width: 60px;
            height: 60px;
            border-radius: 12px;
            margin-right: 14px;
          }
          > div {
            > p:nth-child(1) {
              color: #333333;
              font-size: 13px;
              font-weight: 700;
              margin-bottom: 7px;
            }
            > p:nth-child(2) {
              color: #9f7155;
              font-size: 10px;
              line-height: 13px;
              width: 180px;
            }
          }
          > button {
            width: 71px;
            height: 30px;
            background: #ff5043;
            border-radius: 15px;
            outline: none;
            border: none;
            color: #ffffff;
            font-size: 14px;
            &.hasGet {
              background: #919191;
            }
          }
        }
        > p {
          font-size: 10px;
          color: #fc5f5e;
        }
      }
    }
  }
  .nodata {
    text-align: center;
    color: #cccccc;
    margin-top: 10px;
  }
}
</style>
<style lang="scss">
.sign-act {
  .van-pagination__item {
    color: #fc5f5e;
  }
  .van-pagination__item--active {
    background-color: #fc5f5e;
    color: #ffffff;
  }
}
</style>
<style lang="scss" module>
.rank {
  width: 365px;
  height: 433px;
  background: #ffffff;
  border-radius: 12px;
  padding: 9px 9px 0 9px;

  .rankTitle {
    width: 100%;
    height: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .rankIcon {
      width: 98px;
      height: 19.5px;
      object-fit: contain;
    }

    .rankMore {
      width: 90px;
      height: 12px;
      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #4c9cff;
      line-height: 12px;
      text-decoration: underline;
    }
  }

  .rankList {
    width: 100%;
    height: 370px;
    // background-color: pink;
    overflow-x: hidden;
    overflow-y: auto;

    .ri {
      width: 100%;
      height: 53px;
      position: relative;
      padding: 10px 10px;
      display: flex;
      align-items: center;
      margin-bottom: 14px;

      .rankIcon {
        width: 28px;
        height: 25.5px;
        background-size: 100% 100%;
        margin-right: 7.4px;
      }

      .gameItem {
        display: flex;
        align-items: center;
        > img {
          width: 53px;
          height: 53px;
          border-radius: 8px;
          margin-right: 5.3px;
        }
        .content {
          width: 150px;

          .name {
            // height: 12.5px;
            font-size: 13px;
            font-weight: 500;
            text-align: left;
            color: #000000;
            margin-bottom: 4.5px;
            padding: 1px 0;
          }
          .desc {
            // height: 10px;
            font-size: 10px;
            font-weight: 400;
            text-align: left;
            color: #858585;
            margin-bottom: 3px;
            line-height: 1;
            padding: 1px 0;
          }

          .tags {
            > span {
              background: #fef3ef;
              border-radius: 4px;
              text-align: center;
              line-height: 13.5px;
              font-size: 9.5px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: center;
              color: #f67643;
              margin-right: 4px;
            }
            .tag {
              padding: 0 3px;
            }
          }
        }
      }
      .download {
        position: absolute;
        right: 15px;
        width: 73px;
        height: 26px;
        background: linear-gradient(-87deg, #ff5443 0%, #fe7b2b 100%) #000000;
        border-radius: 13.54px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
      }
    }
  }
}
</style>
